export default {"src":"https://static.smartdeer.com/global/mkt/_next/static/media/facebook.6726c8ae.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};